module.exports = __webpack_public_path__ + "img/lucy-min.0ffeec33.png";